





























































































































import { Component, Vue, Watch } from "vue-property-decorator";
import CourseForm from "@/components/courses/CourseForm.vue";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
import { scormApi } from "@/getinfo-api";
import {
  Scorm as IScorm,
  ScormImport as IScormImport
} from "@/api-v2/scorm/models";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import { getCurrentCompanyId, isRoot } from "@/plugins/roles";
import CustomButton from "@/components/form/CustomButton.vue";
import CField from "@/components/form/CField.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import EditorWithFile from "@/components/EditorWithFile.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import categories, { CategoriesListParams } from "@/getinfo-api/categories";
import {
  CategoryList as ICategoryList,
  EmployeesList2 as IEmployeesList2
} from "@/api/models";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { LearningMaterialLocales } from "@/plugins/custom-interface";

@Component({
  components: {
    CSingleSelect,
    EditorWithFile,
    CField,
    CustomButton,
    CBlock,
    CBreadCrumbs,
    CourseForm
  }
})
export default class CourseScormCreate extends Vue {
  scormForm: any = {
    companyId: this.selectedCompany,
    file: undefined,
    title: "",
    path: "scorm/",
    categoryId: "",
    description: " ",
    responsibleId: ""
  };
  scorm!: IScorm;
  selected!: string;
  isLoading: boolean = false;
  categoryList: Array<any> = [];
  responsibleList!: IEmployeesList2;
  locale: string = "";

  data() {
    return {
      scorm: undefined,
      responsibleList: undefined
    };
  }

  get locales() {
    return LearningMaterialLocales();
  }

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  getResponsibleList() {
    let params: EmployeeListParams = {
      id: this.selectedCompany,
      roles: ["content_manager"],
      limit: 900
    };
    employee(params).then((res: { data: IEmployeesList2 }) => {
      this.responsibleList = res.data;
      if (this.responsibleList.employees.length) {
        if (this.root || this.companyOwner) {
          this.scormForm.responsibleId = this.responsibleList.employees[0].id;
        } else {
          this.scormForm.responsibleId = this.currentEmployee.id;
        }
      }
    });
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get currentEmployee() {
    return this.$store.getters.userIsEmployee;
  }

  get companyDiskId() {
    return this.$store.getters.selectedCompany.diskId;
  }

  async importCourse() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;

    this.isLoading = true;
    try {
      let scormForm: IScormImport = {
        organizationId: this.selected,
        title: this.scormForm.title,
        description: this.scormForm.description,
        categoryId: this.scormForm.categoryId,
        metadata: {
          scormVersion: this.scorm.version
        },
        responsibleId: this.scormForm.responsibleId
      };
      if (this.scorm && this.scorm.id) {
        await scormApi.Scorm.importScorm(this.scorm.id, scormForm)
          .then(res => {
            this.$router.push({
              name: "courseInfoCreate",
              params: { id: res.data.id }
            });
          })
          .catch(
            (err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
              this.$store.dispatch("errorException", {
                vm: this,
                error: err.response
              });
            }
          );
      }
    } catch (e) {
      throw new Error(e);
    } finally {
      this.isLoading = false;
    }
  }

  get file() {
    return this.scormForm.file;
  }

  @Watch("file")
  checkForm() {
    this.scormForm.path = `scorm/${this.file.name}`;
  }
  get companyId() {
    return getCurrentCompanyId();
  }

  getAllCategory() {
    let params: CategoriesListParams = {
      companyId: this.companyId,
      limit: 600
    };
    categories(params)
      .then((res: { data: ICategoryList }) => {
        this.categoryList = res.data.items;
        if (res.data) {
          this.scormForm.categoryId = res.data.items[0].id;
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  async importScorm() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;

    let file = new FormData();
    this.isLoading = true;
    file.append("file", this.scormForm.file);
    scormApi.Scorm.uploadScorm(
      this.scormForm.companyId,
      this.companyDiskId,
      this.scormForm.file,
      this.scormForm.title,
      this.scormForm.path,
      this.scormForm.description
    )
      .then(res => {
        this.scorm = res.data;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
  get breadcrumbs() {
    return [
      {
        to: { name: "courses" },
        label: this.$tc(this.$translate.Courses)
      },
      {
        label: `${this.$tc(this.$translate.NewSCORM)}`
      }
    ];
  }
  created() {
    this.getResponsibleList();
    this.getAllCategory();
  }
}
